<div class="registration-settings">
  <section class="registration-settings__section">
    <h5>{{ 'account.admin.platformMode.title' | transloco }}</h5>
    <e-segmented-toggle
      [options]="modeOptions()"
      [value]="platformMode.mode()"
      [disabled]="isModePending()"
      [groupLabel]="'account.admin.platformMode.title' | transloco"
      testId="platform-mode"
      (valueChange)="onModeChange($event)"
    ></e-segmented-toggle>
    <p class="registration-settings__hint">{{ 'account.admin.platformMode.hint' | transloco }}</p>
    @if (!platformMode.hasFullAccess()) {
      <p class="registration-settings__hint registration-settings__hint--warning">
        {{ 'account.admin.platformMode.needsFullAccess' | transloco }}
      </p>
    }
  </section>

  <section class="registration-settings__section">
    <h5>{{ 'account.admin.registrationTitle' | transloco }}</h5>
    <label class="registration-settings__toggle">
      <e-switch
        [value]="registrationEnabled()"
        (valueChange)="onToggleRegistration($event)"></e-switch>
      <span>{{ 'account.admin.registrationToggleLabel' | transloco }}</span>
    </label>
    <p class="registration-settings__hint">{{ 'account.admin.registrationToggleHint' | transloco }}</p>
  </section>

  <section class="registration-settings__section">
    <h5>{{ 'account.admin.keysTitle' | transloco }}</h5>
    <p class="registration-settings__hint">{{ 'account.admin.keysHint' | transloco }}</p>

    <div class="registration-settings__create">
      <select class="form-select form-select-sm" [(ngModel)]="newKeyUserGroupId">
        @for (group of userGroups(); track group.id) {
          <option [ngValue]="group.id">{{ group.name }}</option>
        }
      </select>
      <input
        class="form-control form-control-sm"
        type="datetime-local"
        [(ngModel)]="newKeyExpiresOn"
        [title]="'account.admin.keyExpiresOn' | transloco" />
      <button
        eBtn
        size="sm"
        color="highlight"
        icon="plus"
        [loading]="isCreatingKey()"
        [disabled]="!newKeyUserGroupId"
        (click)="onCreateKey()">
        {{ 'account.admin.createKey' | transloco }}
      </button>
    </div>

    <ul class="registration-settings__keys">
      @for (key of registrationKeys(); track key.id) {
        <li class="registration-settings__key" [class.registration-settings__key--inactive]="!key.isUsable">
          <div class="registration-settings__key-main">
            <code>{{ key.code }}</code>
            <span class="registration-settings__key-group">{{ key.userGroupName }}</span>
          </div>
          <div class="registration-settings__key-meta">
            @if (key.isUsed) {
              <span class="text-muted">{{ 'account.admin.keyUsedBy' | transloco: { email: key.usedByUserAccountEmail } }}</span>
            } @else if (key.isRevoked) {
              <span class="text-danger">{{ 'account.admin.keyRevokedLabel' | transloco }}</span>
            } @else if (key.hasExpired) {
              <span class="text-danger">{{ 'account.admin.keyExpired' | transloco }}</span>
            } @else {
              <span class="text-success">{{ 'account.admin.keyUsable' | transloco }}</span>
              @if (key.expiresOn) {
                <span class="text-muted">{{ key.expiresOn | dateTimeFormat: 'standard' }}</span>
              }
            }
          </div>
          <div class="registration-settings__key-actions">
            @if (key.isUsable) {
              <button eBtn size="sm" color="light" icon="copy" (click)="onCopyCode(key)"></button>
              <button eBtn size="sm" color="danger" icon="ban" (click)="onRevokeKey(key)"></button>
            }
          </div>
        </li>
      } @empty {
        <li class="registration-settings__empty text-muted">{{ 'account.admin.noKeys' | transloco }}</li>
      }
    </ul>
  </section>
</div>
